<template>
	<v-text-field
		v-model="model"
		class="search-input"
		clearable
		:color="color"
		:density="density"
		:disabled
		hide-details
		:placeholder="t('common.placeholders.search')"
		variant="outlined"
		@click:clear="emit('close')"
	>
		<template #prepend-inner>
			<sk-icon color="secondary" icon="$search" size="sm" />
		</template>
	</v-text-field>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { VTextField } from 'vuetify/components';

import { SkIcon } from '@silae/components';
import { UiDensity } from '@silae/helpers';

const { t } = useI18n();

defineProps({
  minWidth: { default: '210px' },
  modelValue: null,
  color: { default: 'secondary' },
  density: { default: UiDensity.COMPACT },
  disabled: { type: Boolean }
});

const model = defineModel<string>();

const emit = defineEmits(["close"]);
</script>

<style scoped>
.search-input {
	min-width: v-bind(minWidth);
}
</style>
